import { animate, animateChild, animation, AUTO_STYLE, keyframes, query, style, transition, trigger } from '@angular/animations';
import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-scroll-to-top',
  // host: {'(window:scroll)': 'track($event)'},
  templateUrl: './scroll-to-top.component.html',
  styleUrls: ['./scroll-to-top.component.scss'],
  animations: [
    trigger('ngIfAnimation', [
      transition(':enter', [style({ height: 0, opacity: 0 }), animate('0.2s ease-out', style({ height: 64, opacity: 1 })), query('@*', animateChild())]),
      transition(':leave', [style({ height: 64, opacity: 1 }), animate('0.2s ease-in', style({ height: 0, opacity: 0 }))]),
    ]),
    trigger('bounceAnimation', [
      transition(':enter', [style({ 'transform-origin': 'center bottom' }), animate(
        '{{duration}}ms {{delay}}ms',
        keyframes([
          style({ visibility: AUTO_STYLE, transform: 'translate3d(0, 0, 0)', easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)', offset: 0 }),
          style({ transform: 'translate3d(0, 0, 0)', easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)', offset: 0.2 }),
          style({ transform: 'translate3d(0, -10px, 0)', easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)', offset: 0.4 }),
          style({ transform: 'translate3d(0, -10px, 0)', easing: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)', offset: 0.43 }),
          style({ transform: 'translate3d(0, 0, 0)', easing: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)', offset: 0.53 }),
          style({ transform: 'translate3d(0, -8px, 0)', easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)', offset: 0.6 }),
          style({ transform: 'translate3d(0, 0, 0)', easing: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)', offset: 0.7 }),
          style({ transform: 'translate3d(0, -5px, 0)', easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)', offset: 0.8 }),
          style({ transform: 'translate3d(0, 0, 0)', easing: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)', offset: 0.85 }),
          style({ transform: 'translate3d(0, -2px, 0)', easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)', offset: 0.9 }),
          style({ transform: 'translate3d(0, 0, 0)', easing: 'ease', offset: 1 })
        ])
      )],
        {
          params: {
            delay: 20,
            duration: 1000
          }
        }
      )
    ])
  ],
})
export class ScrollToTopComponent implements OnInit {
  showButton = false;

  @HostListener('window:scroll', ['$event'])
  track(event) {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      this.showButton = true;
    } else {
      this.showButton = false;
    }
  }

  constructor() {}

  ngOnInit(): void {
    this.showButton = window.pageYOffset > 20;
  }

  scroll(): void {
    window.scrollTo(0, 0);
  }
}

